import * as tslib_1 from "tslib";
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var DataDictionaryApi = /** @class */ (function () {
    function DataDictionaryApi(api) {
        this.api = api;
    }
    DataDictionaryApi.prototype.getColumnsWithDomainValuesByMetaTableId = function (tableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var retVals, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retVals = [];
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetMetaTable($tableId: [Int]) {\n                metaTables(id: $tableId) {\n                    columns {\n                        columnName\n                        columnAlias\n                        domainValues {\n                            codeValue\n                            longDescription\n                            shortDescription\n                        }\n                    }\n                }\n            }\n        ", { tableId: tableId }, 'GET', 'metaTables')];
                    case 1:
                        results = _a.sent();
                        if (results && results.length) {
                            retVals = results[0].columns;
                        }
                        return [2 /*return*/, retVals];
                }
            });
        });
    };
    DataDictionaryApi.prototype.getColumnsWithDomainValuesByTableName = function (tableName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var retVals, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retVals = [];
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetMetaTable($tableName: [String]) {\n                metaTables(name: $tableName) {\n                    columns {\n                        columnName\n                        columnAlias\n                        domainValues {\n                            codeValue\n                            longDescription\n                            shortDescription\n                        }\n                    }\n                }\n            }\n        ", { tableName: tableName }, 'GET', 'metaTables')];
                    case 1:
                        results = _a.sent();
                        if (results && results.length) {
                            retVals = results[0].columns;
                        }
                        return [2 /*return*/, retVals];
                }
            });
        });
    };
    DataDictionaryApi.ngInjectableDef = i0.defineInjectable({ factory: function DataDictionaryApi_Factory() { return new DataDictionaryApi(i0.inject(i1.Api)); }, token: DataDictionaryApi, providedIn: "root" });
    return DataDictionaryApi;
}());
export { DataDictionaryApi };
